<template>

  <v-dialog :value="visivel" @input="$emit('update:visivel', $event)" :max-width="Modal.Confirmacao.larguraMaxima" persistent>
    <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
      <v-card-title class="primary modal-title" primary-title>
        <slot name="header">
        </slot>
        <v-btn flat depressed @click="$emit('fechar')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text class="pb-0 az-form-content">
        <slot name="primario"/>
      </v-card-text>
      
      <v-card-text v-if="$slots.secudario" class="az-form-content pb-0">
        <slot name="secundario" />
      </v-card-text>
      
      <v-card-actions class="px-3 py-2">
        <slot name="acoes" />
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'ModalGenerico',
    computed: {
        Modal() {
            return Modal
        }
    },
    props: {
        visivel: Boolean
    }
}

</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
       padding 0 25px
       border 1px solid var(--v-primary-base) !important
       background-color var(--v-primary-base) !important
       color #fff !important
       box-sizing border-box
       margin-left 15px !important
</style>